import script from "./CtrlCuartofrio.vue?vue&type=script&lang=ts&setup=true"
export * from "./CtrlCuartofrio.vue?vue&type=script&lang=ts&setup=true"

import "./CtrlCuartofrio.vue?vue&type=style&index=0&id=36de54e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36de54e3"]])

export default __exports__